







































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { IUser, Callback } from "@/interfaces";
import { PASSWORD_RULES, EMAIL_VALIDATORS } from "@/validators";
import { ChangeUserEmail, ChangePass } from "@/api";
import { Getter, Action } from "vuex-class";
import { UserInterface } from "@/utils/UserInterface";

@Component({
})
export default class UserLoginFormComponent extends Vue {
  @Prop({ required: true }) user!: IUser;
  @Prop({ required: true }) id!: number | null;
  @Getter("isAdmin", { namespace: "AppModule" })
  public isAdmin!: boolean;
  @Action("setSnackbar", { namespace: "AppModule" })
  public setSnackbarAction!: Callback;
  public buttonLoading1 = false;
  public buttonLoading2 = false;
  public valid1 = false;
	public valid2 = false;
	public showPass1:boolean=false;
	public showPass2: boolean=false;
  public form1 = {
    NewEmail: ""
  };
  public form2 = {
    NewPass: "",
    CurrPass: "",
    PassConfirm: ""
  };
  public emailRules = EMAIL_VALIDATORS;
  public passRules = PASSWORD_RULES;

	private UI__: UserInterface;

	mounted() {
    this.UI__ = new UserInterface(this);
  }

  async validateEmail() {
    if ((this.$refs.changeEmailForm as HTMLFormElement).validate()) {

      try {
        this.buttonLoading1 = true;
        const resp = await ChangeUserEmail(this.id!, this.form1.NewEmail);
        this.buttonLoading1 = false;
        if (resp.Ok) {
          this.$router.push("/users");

					/// WILL DISPATCH A NOTIFICATION,
					/// SO COMPONENTS SHOWING USERS WILL REFRESH
					/// TO SHOW UPDATED DATA.
					this.UI__.RefreshTimestampUsers();


          this.setSnackbarAction({
            message: `User email changed successfully`,
            status: "success"
          });
        }
      } catch (err) {
        //
      }
    }
  }

  async validatePass() {
    if ((this.$refs.chanegPassForm as HTMLFormElement).validate()) {
			
			if (this.form2.NewPass!=this.form2.PassConfirm){

				this.setSnackbarAction({
					message: `Password and Confirmation doesn't match`,
					status: "error"
				});

				return;
			}

      try {
        this.buttonLoading2 = true;
        const resp = await ChangePass(
          this.id!,
          this.isAdmin ? "" : this.form2.CurrPass,
          this.form2.NewPass
        );
        this.buttonLoading2 = false;
        if (resp.Ok) {
          this.$router.push("/users");
          this.setSnackbarAction({
            message: `User password changed successfully`,
            status: "success"
          });
        }
      } catch (err) {
        //
      }
    }
  }
}


